// extracted by mini-css-extract-plugin
export var actions = "_3q-0";
export var actionsContainer = "_3q-6";
export var border = "_3q-1";
export var childFullHeight = "_3q-d";
export var collapse = "_3q-2";
export var content = "_3q-8";
export var contentChild = "_3q-c";
export var fullscreen = "_3q-a";
export var headerContainer = "_3q-3";
export var headerRow = "_3q-5";
export var hidePadding = "_3q-9";
export var noScrollX = "_3q-e";
export var noScrollY = "_3q-f";
export var optOutTopPadding = "_3q-b";
export var pagePadding = "_3q-7";
export var profile = "_3q-g";
export var profileContainer = "_3q-h";
export var profileImage = "_3q-i";
export var profileMain = "_3q-j";
export var profileSubtitle = "_3q-l";
export var profileTitle = "_3q-k";
export var tabsWrapper = "_3q-4";
export var title = "_3q-m";